<template>
  <img src="@/assets/img/Icons/compass.svg" />
</template>

<script>
export default {};
</script>

<style></style>
